import React, { useState, useEffect } from "react";
import {
  FaUser, FaQuestionCircle, FaTags, FaFileAlt, FaListUl, FaPhone, FaEnvelope, FaBuilding, FaLanguage, FaMapMarkerAlt, FaFileInvoice, FaImage, FaIdCard, FaFilePdf, FaSearch, FaPlus, FaTimes
} from "react-icons/fa";
import { RiQuestionAnswerFill } from "react-icons/ri";
import axios from 'axios'
import toast from "react-hot-toast";
import Select from 'react-select';
import { Button, Card } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";




function Master_Question({ token }) {

  const [showForm, setShowForm] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [lan, setLan] = useState([]);
  const [botQuestions, setBotQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);


  const [formData, setFormData] = useState({
    lang_id: '',
    user_type: '',
    category_name: '',

    lang1: "",
    question1: "",
    // answer1: "",
 answer1: [""],
    lang2: "",
    question2: "",
    // answer2: "",
 answer2: [""],
    lang3: "",
    question3: "",
    // answer3: "",
     answer3: [""],
  });


  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "profile") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const addAnswer = (answerField) => {

  setFormData({
    ...formData,
    [answerField]: [
      ...formData[answerField],
      ""
    ]
  });

};


const handleAnswerChange = (field, index, value) => {

  const updatedAnswers = [...formData[field]];

  updatedAnswers[index] = value;


  setFormData({
    ...formData,
    [field]: updatedAnswers
  });

};


const removeAnswer = (field, index) => {

  const updatedAnswers = [...formData[field]];

  updatedAnswers.splice(index, 1);

  setFormData({
    ...formData,
    [field]: updatedAnswers
  });

};




  const fetchMasterLanguage = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-master-language",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;
   

      setLan(result);
      console.log(result)
    } catch (error) {
      console.log(error);
    }
  };


  const fetchBotQuestions = async () => {
    try {
      const res = await axios.get(
        "https://api.krimotion.in/fetch-bot-question",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setBotQuestions(res.data);
      console.log(res.data, 'question');

    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    fetchMasterLanguage();
    fetchBotQuestions();

  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();


      const answer1Length = formData.answer1?.length || 0;
  const answer2Length = formData.answer2?.length || 0;
  const answer3Length = formData.answer3?.length || 0;

  if (
    answer1Length !== answer2Length ||
    answer2Length !== answer3Length
  ) {
    toast.error("All answer sections must contain the same number of answers.");
    return;
  }

    try {

      if (isEditMode) {

        await axios.put(
          `https://api.krimotion.in/update-bot-question/${formData.ques_id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        toast.success("Updated Successfully");

      } else {

        await axios.post(
          "https://api.krimotion.in/add-bot-question",
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        toast.success("Saved Successfully");

      }


      setShowForm(false);
      setIsEditMode(false);

      resetForm();
      fetchBotQuestions();


    } catch (err) {

      console.log(err);

      toast.error(
        isEditMode
          ? "Failed to update question"
          : "Failed to add question"
      );

    }
  };




const handleEdit = (selectedData) => {

  const languages = selectedData.languages || [];
  const groupedLanguages = Object.values(
    languages.reduce((acc, item) => {

      if (!acc[item.lang_id]) {

        acc[item.lang_id] = {
          lang_id: item.lang_id,
          question: item.question,
          answers: []
        };

      }


      acc[item.lang_id].answers.push(item.answer);


      return acc;

    }, {})
  );



  setFormData({

    ques_id:selectedData.ques_id,

    user_type:selectedData.user_type,

    category_name:selectedData.category_name,


    // Language 1
    lang1:groupedLanguages[0]?.lang_id || "",
    question1:groupedLanguages[0]?.question || "",
    answer1:groupedLanguages[0]?.answers || [""],



    // Language 2
    lang2:groupedLanguages[1]?.lang_id || "",
    question2:groupedLanguages[1]?.question || "",
    answer2:groupedLanguages[1]?.answers || [""],



    // Language 3
    lang3:groupedLanguages[2]?.lang_id || "",
    question3:groupedLanguages[2]?.question || "",
    answer3:groupedLanguages[2]?.answers || [""],

  });



  setIsEditMode(true);
  setShowForm(true);

};


  const handleDeleteQuestion = async () => {

    try {

      await axios.delete(
        `https://api.krimotion.in/delete-bot-question/${selectedQuestion.ques_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );


      toast.success("Question deleted successfully");

      setShowDeleteModal(false);

      fetchBotQuestions(); // reload list

    } catch (error) {

      console.log(error);
      toast.error("Delete failed");

    }

  };


  const resetForm = () => {
    setFormData({
      ques_id: "",
      user_type: "",
      category_name: "",
      lang1: "",
      question1: "",
      answer1: "",
      lang2: "",
      question2: "",
      answer2: "",
      lang3: "",
      question3: "",
      answer3: "",
    });

    setIsEditMode(false);
    setEditingCompanyId(null);


  };




  const groupedQuestions = Object.values(
    botQuestions.reduce((acc, item) => {

      if (!acc[item.ques_id]) {
        acc[item.ques_id] = {
          ques_id: item.ques_id,
          user_type: item.user_type,
          category_name: item.category_name,
          added_on: item.added_on,
          languages: []
        };
      }

      acc[item.ques_id].languages.push({
        lang_id: item.lang_id,
        language: item.language,
        question: item.question,
        answer: item.answer
      });

      return acc;

    }, {})
  );



  return (
    <div className="container py-4">
      <div className="border-0  mb-3 px-2 py-2  ">

        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

          {/* LEFT TITLE */}
          <div className="d-flex align-items-center">
            <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
              Manage Master Question
            </h4>
          </div>

          {/* CENTER SEARCH */}
          <div style={{ flex: 1, maxWidth: "250px" }}>
            <div
              className="d-flex align-items-center rounded-pill overflow-hidden"
              style={{
                border: "1px solid var(--green)",
                height: "34px",
                paddingLeft: "8px",
                paddingRight: "8px",
                backgroundColor: 'white'
              }}
            >
              {/* ICON */}
              <FaSearch
                style={{
                  color: "var(--green)",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center"
                }}
              />

              {/* INPUT */}
              <input
                type="text"
                className="form-control border-0 shadow-none"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  fontSize: "14px",
                  height: "32px",
                  marginLeft: "6px",
                  lineHeight: "32px"
                }}
              />
            </div>
          </div>

          {/* RIGHT BUTTON */}
          <div className="d-flex align-items-center gap-2">
            {!showForm ? (
              <>
                <button
                  className="btn btn-sm px-3 "
                  onClick={() => setShowForm(true)}
                  style={{
                    backgroundColor: "var(--green)",
                    color: "white",
                    fontSize: "13px",
                    height: "34px"
                  }}
                >
                  <FaPlus className="me-1" />
                  Add
                </button>

              </>
            ) : (
              <button
                className="btn btn-danger btn-sm px-3"
                onClick={() => {
                  resetForm();
                  setShowForm(false);
                }}
                style={{ height: "34px", fontSize: "13px" }}
              >
                <FaTimes className="me-1" />
                Close
              </button>
            )}
          </div>

        </div>
      </div>


      {showForm && (
        <div className="card shadow-sm border-0 rounded-4 p-3">

          <form onSubmit={handleSubmit}>

            <div className="row g-2">


              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Select User Type
                </label>

                <div className="input-group">
                  <span className="input-group-text">
                    <FaUser />
                  </span>

                  <select
                    className="form-select"
                    name="user_type"
                    value={formData.user_type}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select User Type</option>
                    <option value="customer">Customer</option>
                    <option value="dealer">Dealer</option>
                    <option value="driver">Driver</option>
                  </select>
                </div>
              </div>



              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Select Category
                </label>

                <div className="input-group">
                  <span className="input-group-text">
                    <FaTags />
                  </span>

                  <select
                    className="form-select"
                    name="category_name"
                    value={formData.category_name}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Category</option>
                    <option value="Vehicle">Vehicle</option>
                    <option value="Machine">Machine</option>
                    <option value="Spares">Spare</option>
                    <option value="General">General</option>
                  </select>
                </div>
              </div>


              <div className="row g-2">

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Select Language 1
                  </label>

                  <div className="input-group">
                    <span className="input-group-text">
                      <FaLanguage />
                    </span>

                    <select
                      className="form-select"
                      name="lang1"
                      value={formData.lang1}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Language</option>

                      {lan.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.term}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>



                <div className="col-md-6">
                  <label className="form-label fw-semibold">Enter Question 1 </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaQuestionCircle  />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      name="question1"
                      value={formData.question1}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>


                {/* <div className="col-md-6">
                  <label className="form-label fw-semibold">Enter Answer 1 </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaQuestionCircle />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      name="answer1"
                      value={formData.answer1}
                      onChange={handleInputChange}
                      required
                    />

                  </div>
                </div> */}

                <div className="col-md-6">

<div className="d-flex justify-content-between align-items-center mb-2">

  <label className="form-label fw-semibold mb-0">
    Enter Answer 1
  </label>

  <button
    type="button"
    className="btn btn-sm btn-success"
    onClick={() => addAnswer("answer1")}
  >
    + Add Answer
  </button>

</div>



{Array.isArray(formData.answer1) && formData.answer1.map((answer, index) => (

<div className="input-group mb-2" key={index}>

  <span className="input-group-text">
    <RiQuestionAnswerFill />
  </span>
  <input
    type="text"
    className="form-control"
    placeholder={`Answer ${index + 1}`}
    value={answer}
    onChange={(e)=>
      handleAnswerChange(
        "answer1",
        index,
        e.target.value
      )
    }
  />


  {/* Delete Button */}
  {/* {formData.answer1.length > 1 && (
    <button
      type="button"
      className="btn btn-danger"
      onClick={() =>
        removeAnswer(
          "answer1",
          index
        )
      }
    >
      ✕
    </button>
  )} */}

</div>

))}



</div>

              </div>

              <div className="row g-2">

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Select Language 2
                  </label>

                  <div className="input-group">
                    <span className="input-group-text">
                      <FaLanguage />
                    </span>

                    <select
                      className="form-select"
                      name="lang2"
                      value={formData.lang2}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Language</option>

                      {lan.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.term}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Enter Quesion 2 </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaQuestionCircle />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      name="question2"
                      value={formData.question2}
                      onChange={handleInputChange}
                      required
                    />

                  </div>
                </div>


                <div className="col-md-6">

                  {/* <label className="form-label fw-semibold">Enter Answer 2 </label> */}
                  <div className="d-flex justify-content-between align-items-center mb-2">

  <label className="form-label fw-semibold mb-0">
    Enter Answer 2
  </label>

  <button
    type="button"
    className="btn btn-sm btn-success"
    onClick={() => addAnswer("answer2")}
  >
    + Add Answer
  </button>

</div>
                  {/* <div className="input-group">
                    <span className="input-group-text">
                      <RiQuestionAnswerFill />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      name="answer2"
                      value={formData.answer2}
                      onChange={handleInputChange}
                      required
                    />

                  </div> */}

                  
{Array.isArray(formData.answer2) && formData.answer2.map((answer, index) => (

<div className="input-group mb-2" key={index}>

  <span className="input-group-text">
    <RiQuestionAnswerFill />
  </span>


  <input
    type="text"
    className="form-control"
    placeholder={`Answer ${index + 1}`}
    value={answer}
    onChange={(e)=>
      handleAnswerChange(
        "answer2",
        index,
        e.target.value
      )
    }
  />


  {/* Delete Button */}
  {/* {formData.answer2.length > 1 && (
    <button
      type="button"
      className="btn btn-danger"
      onClick={() =>
        removeAnswer(
          "answer2",
          index
        )
      }
    >
      ✕
    </button>
  )} */}

</div>

))}
                </div>
              </div>


              <div className="row g-2">

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Select Language 3
                  </label>

                  <div className="input-group">
                    <span className="input-group-text">
                      <FaLanguage />
                    </span>

                    <select
                      className="form-select"
                      name="lang3"
                      value={formData.lang3}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Language</option>

                      {lan.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.term}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>



                <div className="col-md-6">
                  <label className="form-label fw-semibold">Enter Question 3 </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <FaQuestionCircle />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      name="question3"
                      value={formData.question3}
                      onChange={handleInputChange}
                      required
                    />

                  </div>
                </div>


                <div className="col-md-6">
                  {/* <label className="form-label fw-semibold">Enter Asnwer 3</label> */}

                             <div className="d-flex justify-content-between align-items-center mb-2">

  <label className="form-label fw-semibold mb-0">
    Enter Answer 3
  </label>

  <button
    type="button"
    className="btn btn-sm btn-success"
    onClick={() => addAnswer("answer3")}
  >
    + Add Answer
  </button>

</div>

                  {/* <div className="input-group">
                    <span className="input-group-text">
                      < RiQuestionAnswerFill />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      name="answer3"
                      value={formData.answer3}
                      onChange={handleInputChange}
                      required
                    />

                  </div> */}

                  {Array.isArray(formData.answer3) && formData.answer3.map((answer, index) => (

<div className="input-group mb-2" key={index}>

  <span className="input-group-text">
    <RiQuestionAnswerFill />
  </span>


  <input
    type="text"
    className="form-control"
    placeholder={`Answer ${index + 1}`}
    value={answer}
    onChange={(e)=>
      handleAnswerChange(
        "answer3",
        index,
        e.target.value
      )
    }
  />


  {/* Delete Button */}
  {/* {formData.answer3.length > 1 && (
    <button
      type="button"
      className="btn btn-danger"
      onClick={() =>
        removeAnswer(
          "answer3",
          index
        )
      }
    >
      ✕
    </button>
  )} */}

</div>

))}
                </div>
              </div>



              {/* Save Button */}
              <div className="col-12 text-end">
                <button type="submit" className="btn-action btn-success-custom" style={{ backgroundColor: "var(--green)", color: 'white' }}>
                  {isEditMode ? "Update  " : " Save "}
                </button>
              </div>

            </div>
          </form>
        </div>
      )}

      {!showForm && (

        <div className="container-fluid mt-4">

          <div className="row g-4">

            {groupedQuestions.map((item) => (

              <div className="col-xl-4 col-lg-6 col-md-6" key={item.ques_id}>

                <div className="user-card h-100">


                  {/* Header */}

                  <div className="d-flex justify-content-between align-items-center mb-3">

                    <div>

                      <h5 className="fw-bold mb-1">
                        Question ID : {item.ques_id}
                      </h5>

                      <span className="badge bg-primary">
                        {item.user_type}
                      </span>

                      <span className="badge bg-warning text-dark ms-2">
                        {item.category_name}
                      </span>

                    </div>

                  </div>



                  <hr />


                  {/* Language Questions */}
{/* 
                  {
                    item.languages.map((lang, index) => (

                      <div
                        className="mb-3 p-3 rounded shadow-sm"
                        style={{
                          background: "#f8f9fa"
                        }}
                        key={index}
                      >


                        <div className="d-flex justify-content-between">

                          <strong>
                            {lang.language}
                          </strong>


                          <span className="badge bg-success">
                            Language ID {lang.lang_id}
                          </span>


                        </div>



                        <div className="mt-2">

                          <small className="text-muted">
                            Question
                          </small>

                          <p className="mb-2 fw-semibold">
                            {lang.question}
                          </p>


                          <small className="text-muted">
                            Answer
                          </small>

                          <p className="mb-0">
                            {lang.answer}
                          </p>


                        </div>


                      </div>

                    ))

                  } */}

{/* Default Language */}
{item.languages.length > 0 && (

  <div
    className="mb-3 p-3 rounded shadow-sm"
    style={{ background: "#f8f9fa" }}
  >

    <div className="d-flex justify-content-between">

      <strong>{item.languages[0].language}</strong>

      <span className="badge bg-success">
        Language ID {item.languages[0].lang_id}
      </span>

    </div>

    <div className="mt-2">

      <small className="text-muted">
        Question
      </small>

      <p className="fw-semibold">
        {item.languages[0].question}
      </p>

      <small className="text-muted">
        Answers
      </small>

      <ul className="mb-0 ps-3">
        {item.languages[0].answer
          ?.split("|")
          .filter(a => a.trim())
          .map((ans, i) => (
            <li key={i}>{ans}</li>
          ))}
      </ul>

    </div>

  </div>

)}

{/* Remaining Languages */}
{item.languages.length > 1 && (

  <div className="accordion" id={`acc-${item.ques_id}`}>

    {item.languages.slice(1).map((lang, index) => (

      <div className="accordion-item" key={index}>

        <h2 className="accordion-header">

          {/* <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse-${item.ques_id}-${index}`}
          >
            {lang.language}
          </button> */}

        </h2>

        <div
          id={`collapse-${item.ques_id}-${index}`}
          className="accordion-collapse collapse"
        >

          <div className="accordion-body">

            <small className="text-muted">
              Question
            </small>

            <p className="fw-semibold">
              {lang.question}
            </p>

            <small className="text-muted">
              Answers
            </small>

            <ul className="ps-3 mb-0">
              {lang.answer
                ?.split("|")
                .filter(a => a.trim())
                .map((ans, i) => (
                  <li key={i}>{ans}</li>
                ))}
            </ul>

          </div>

        </div>

      </div>

    ))}

  </div>

)}


                  <div className="mt-auto pt-3">


                    <div className="d-flex gap-2">


                      <button
                        className="btn-action btn-primary-custom"
                        onClick={() => handleEdit(item)}
                      >
                        <i className="bi bi-pencil"></i>
                        Edit
                      </button>



                      <button
                        className="btn-action btn-danger-custom"
                        onClick={() => {

                          setSelectedQuestion(item);
                          setShowDeleteModal(true);

                        }}
                      >
                        <i className="bi bi-trash"></i>
                        Delete
                      </button>



                    </div>


                  </div>



                </div>

              </div>


            ))}



          </div>

        </div>

      )}


      {showDeleteModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowDeleteModal(false)}
          ></div>

          {/* Modal */}
          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content border-0 shadow-lg"
                style={{ borderRadius: "16px" }}
              >
                {/* Header */}
                <div className="modal-header bg-danger text-white">
                  <h5 className="modal-title fw-bold">
                    🗑 Delete Question
                  </h5>

                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setShowDeleteModal(false)}
                  ></button>
                </div>

                {/* Body */}
                <div className="modal-body text-center py-4">
                  <div style={{ fontSize: "60px" }}>⚠️</div>

                  <h5 className="mt-3 fw-bold">
                    Are you sure?
                  </h5>

                  <p className="text-muted mb-0">
                    You are about to permanently delete this question.
                  </p>

                  <p className="text-danger fw-semibold mt-3">
                    This action cannot be undone.
                  </p>
                </div>

                {/* Footer */}
                <div className="modal-footer border-0 justify-content-center">
                  <button
                    className="btn btn-outline-secondary px-4"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-danger px-4"
                    onClick={handleDeleteQuestion}
                  >
                    🗑 Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}



    </div>
  )
}

export default Master_Question
